import { push } from 'connected-react-router';
import { all, call, put, select, spawn, take } from 'redux-saga/effects';
import { serviceUnavailable } from '../../modules/app/actions';
import {
  ConnectionError,
  NotFoundError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../modules/app/errors';
import { restartUserJourney } from '../../modules/auth/saga';
import { close, open } from '../../modules/modal/actions';
import { LINK_SUCCESS } from '../../routes/paths';
import * as form from '../FormMessage/actions';
import i18n from '../i18n/i18n';
import { getLocale } from '../i18n/selectors';
import {
  linkAccountFailure,
  linkAccountSuccess,
  LOGIN_SUCCESS,
  REGISTRATION_SUCCESS
} from './actions';
import { AccountConflictError, AccountForbiddenError } from './errors';
import { linkAccount } from './rest';

/* eslint-disable no-constant-condition */
function* linkWithOnlineAccount(casTicket) {
  const locale = yield select(getLocale);
  try {
    yield put(open({ componentName: 'RequestInProgress' }));
    yield call(linkAccount, casTicket);
    yield put(close());
    yield put(push(LINK_SUCCESS));
    yield put(form.setMessage(form.SUCCESS, i18n('linkingAccounts', 'successMessage', locale)));
    yield put(linkAccountSuccess());
  } catch (e) {
    yield put(close());
    if (e instanceof AccountForbiddenError) {
      yield put(form.setMessage(form.ERROR, i18n('linkingAccounts', 'linkingError', locale)));
    } else if (e instanceof NotFoundError) {
      yield put(form.setMessage(form.ERROR, i18n('linkingAccounts', 'linkingError', locale)));
    } else if (e instanceof AccountConflictError) {
      yield put(form.setMessage(form.ERROR, i18n('linkingAccounts', 'alreadyLinked', locale)));
    } else if (e instanceof UnauthorizedAccessError) {
      yield call(restartUserJourney);
    } else if (e instanceof ConnectionError) {
      yield put(form.setMessage(form.ERROR, i18n('linkingAccounts', 'linkingError', locale)));
    } else if (e instanceof ServiceUnavailableError) {
      yield put(serviceUnavailable());
    } else {
      yield put(linkAccountFailure(e));
      throw e;
    }
    yield put(linkAccountFailure(e));
  }
}

export function* watchRegistrationSuccess() {
  while (true) {
    yield take(REGISTRATION_SUCCESS);
    yield put(open({
      componentName: 'OnlineLogin',
      componentProps: { requestSource: 'registration' }
    }));
  }
}

export function* watchLoginSuccess() {
  while (true) {
    const { casTicket } = yield take(LOGIN_SUCCESS);
    if (!casTicket) {
      yield put(open({ componentName: 'OnlineLogin', componentProps: { requestSource: 'login' } }));
      yield put(linkAccountFailure('No CAS ticket in request'));
    } else {
      yield call(linkWithOnlineAccount, casTicket);
    }
  }
}

export default function* root() {
  yield all([
    spawn(watchRegistrationSuccess),
    spawn(watchLoginSuccess)
  ]);
}
/* eslint-enable no-constant-condition */
